import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { RoleSysAiToolsTelemetry } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'
import { NotFoundPage } from '../../../../page/not-found'
import { AiToolsPage } from './ai-tools-page'
import { SessionDetail } from './session-detail'
import { PostmortemDetail } from './postmortem-detail'
import { AiToolsRecyclePage } from './recycle-page'

// /admin/ai-tools: AI tools telemetry for EducationXR staff (spec 2026-10-20
// §9; contract §8, R32): the list page (Sessions, Postmortems and Findings in
// ?tab=), /admin/ai-tools/sessions/:sessionID and
// /admin/ai-tools/postmortems/:postmortemID, and the recycle bin
// /admin/ai-tools/recycle (its kinds in ?tab=; it also needs delete, which
// the page asks for). The route itself is gated by
// SYS_AI_TOOLS_TELEMETRY read (not only its sidebar entry), so a typed
// address without it says so instead of a page whose every read is refused;
// an address under it that is no page is the app's not-found page.
export const LayoutAiTools = () =>
  <Route path="/admin/ai-tools">
    <RoleSysAiToolsTelemetry accessRead fallback={<NoAccess what="AI tools telemetry" />}>
      <Switch>
        <Route exact path="/admin/ai-tools" component={AiToolsPage} />
        <Route exact path="/admin/ai-tools/recycle" component={AiToolsRecyclePage} />
        <Route path="/admin/ai-tools/sessions/:sessionID(\d+)" component={SessionDetail} />
        <Route path="/admin/ai-tools/postmortems/:postmortemID(\d+)" component={PostmortemDetail} />
        <Route render={({ location }) => <NotFoundPage pathname={location.pathname} />} />
      </Switch>
    </RoleSysAiToolsTelemetry>
  </Route>

// The admin routes are mounted only for staff (LoginSysAdmin), so an
// organization administrator who is not staff saw a blank page at these
// addresses (typed, bookmarked, an old link). They say no access instead.
export const LayoutAiToolsNoStaff = () =>
  <Route path="/admin/ai-tools">
    <NoAccess what="AI tools telemetry" />
  </Route>
